module.exports = __webpack_public_path__ + "img/globe.1d66388.png";